const nodeTypes = [
    {label: "Sinistro", value: "SINISTRO", router: "/regulacao/sinistros/"},
    {label: "Controle de acordo", value: "CRTLACORDO", router: "/regulacao/acordos/"},
    {label: "Controle de Análise", value: "CTRLANALISE", router: "/controle-analise/"},
    {label: "Monitoramento de Imagens", value: "CRTLIMAGES", router: ""}
  ]
export default nodeTypes